/* eslint-disable react/no-unescaped-entities */
/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card, Container, LinearProgress, Grid, Dialog, DialogTitle, DialogContent, Button, Snackbar,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import Moment from 'moment';
import uiActions from '../../../../../../redux/actions/uiActions';
import TestBody from './components/TestBody';
import TestFinished from './components/TestFinished';
import LandingExam from './components/LandingExam';
import examType1Services from '../../../../../../redux/services/examType1Services';
import config from '../../../../../../config';
import { checkExamBeginTime } from '../../../../../../redux/actions/examType1Actions';
import ExamTimer from './components/ExamTimer';
import { Loading } from '../../../../../../helpers/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    overflowY: 'auto',
    marginTop: theme.spacing(1),
    position: 'relative',
    marginBottom: '80px',
  },
  progressBar: {
    width: '100%',
    height: '5px',
  },
  mainTitle: {
    marginTop: '1em',
    textAlign: 'center',
  },
  image: {
    width: '25%',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  textCard: {
    margin: '2em',
    padding: '2em',
    maxWidth: '420px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  h5: {
    color: 'blue',
  },
  button: {
    margin: '20px auto 20px auto',
  },
}));

const PlacementTest = ({
  changePageTitle,
  exam,
  isTest,
  currentExam,
  currentGroup,
  _id,
  activityId,
  additionalTime,
  setFinished,
  setStarted,
}) => {
  const classes = useStyles();

  const [isExamFinished, setIsExamFinished] = useState({ finished: false, date: '', examId: '' });
  const [timeout, setTimeOut] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorSnackBar, setErrorSnackBar] = useState(null);
  const [shown, setShown] = useState(false);
  const [timeLeft, setTimeLeft] = useState((currentExam.duration || 90) + additionalTime);
  const [loading, setLoading] = useState(true);

  const intervalRef = useRef(null);

  const currentQuestion = localStorage.getItem('currentQuestion') !== null ? parseInt(localStorage.getItem('currentQuestion'), 10) : 0;
  const answers = localStorage.getItem('answers') !== null ? JSON.parse(localStorage.getItem('answers')) : [];

  const dates = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];

  const getFormatedDate = (_date) => {
    const date = Moment(_date);
    const day = date.date();
    const month = dates[date.month()];
    const year = date.year();
    const hours = date.hours();
    const minutes = date.minutes();

    return `${hours}h${minutes < 10 && minutes > 0 ? '0' : ''}${minutes > 0 ? minutes : ''} - ${day} ${month}, ${year}`;
  };

  useEffect(() => {
    examType1Services.isExamFinished({
      userId: _id,
      examId: currentExam._id,
    })
      .then((res) => {
        if (res !== null && res.length > 1) {
          const result = res[res.length - 1];
          if (result.isFinished) {
            setIsExamFinished({
              finished: true,
              date: getFormatedDate(new Date(result.updated_at)),
              examId: result._id,
            });
          }
        } else if (res !== null && res.length === 1 && res[0].isFinished) {
          setIsExamFinished({
            finished: true,
            date: getFormatedDate(new Date(res[0].updated_at)),
            examId: res[0]._id,
          });
        } else {
          setIsExamFinished({
            finished: false,
            date: '',
            examId: '',
          });
        }

        setLoading(false);
      })
      .catch(() => {
        setErrorSnackBar({ code: 1801, message: 'Missing exam data.', severity: 'error' });
        setLoading(false);
      });
  }, [exam, currentGroup]);

  useEffect(() => {
    changePageTitle('Examen');
  }, [isTest]);

  useEffect(() => {
    if (exam) {
      const storedTimeLeft = localStorage.getItem('timeLeft');

      if (storedTimeLeft !== null) {
        setTimeLeft(parseInt(storedTimeLeft, 10));
      }

      setStarted(true);
    }
  }, [exam]);

  useEffect(() => {
    if (!exam || isExamFinished.finished || timeout) return undefined;

    const updateTimer = async () => {
      const storedTimeLeft = localStorage.getItem('timeLeft');
      const duration = storedTimeLeft !== null && !Number.isNaN(parseInt(storedTimeLeft, 10))
        ? parseInt(storedTimeLeft, 10)
        : 90;

      const res = checkExamBeginTime(
        additionalTime,
        duration,
        currentExam._id,
      );

      if (res === false) {
        const body = {
          answers: JSON.parse(localStorage.getItem('answers') || '[]'),
          time: 0,
          isFinished: true,
        };

        try {
          const resExam = await examType1Services.isExamFinished({
            userId: _id,
            examId: currentExam._id,
          });

          await examType1Services.sendTest(resExam[0]._id, body);

          setIsExamFinished({
            finished: true,
            date: getFormatedDate(new Date()),
            examId: resExam[0]._id,
          });

          setTimeOut(true);

          clearInterval(intervalRef.current);
          intervalRef.current = null;

          localStorage.removeItem(`examBeginTime_${currentExam._id}`);
        } catch (error) {
          setErrorSnackBar({ code: 1802, message: 'Error sending exam.', severity: 'error' });
        }

        return;
      }

      const minutes = Math.round(res / 1000 / 60);

      setTimeLeft(minutes);

      const storedExam = localStorage.getItem('exam');

      if (!storedExam) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        return;
      }

      const parsedExam = JSON.parse(storedExam);

      if (parsedExam?.testId) {
        await examType1Services.updateExamTimer(parsedExam.testId, { timer: minutes });
      }

      if (minutes <= 5 && !shown) {
        setOpen(true);
        setShown(true);
      }
    };

    updateTimer();

    intervalRef.current = setInterval(updateTimer, 15000);

    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  }, [exam, isExamFinished.finished, timeout]);

  return (
    <>
      {loading === false
        ? (
          <Container>
            <Snackbar open={errorSnackBar !== null} onClose={() => { setErrorSnackBar(null); }} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <Alert severity={errorSnackBar !== null ? errorSnackBar.severity : 'info'} variant="filled" onClose={() => { setErrorSnackBar(null); }}>
                {`Error ${errorSnackBar?.code}: ${errorSnackBar?.message}`}
              </Alert>
            </Snackbar>

            <Dialog
              open={open}
              onClose={() => setOpen(false)}
            >
              <DialogTitle>Examen bientôt terminé.</DialogTitle>
              <DialogContent>{`Il vous reste moins de ${timeLeft} minutes pour terminer l'examen.`}</DialogContent>
              <Button onClick={() => setOpen(false)} autoFocus>
                J&apos;AI COMPRIS
              </Button>
            </Dialog>

            {
              !isExamFinished.finished && exam && currentQuestion !== exam.questions.length && !timeout
                ? <ExamTimer timeLeft={timeLeft} />
                : null
            }

            {!isExamFinished.finished
              ? (
                <Card variant="outlined" className={classes.root}>
                  {exam
                    ? ((currentQuestion === exam.questions.length || timeout)
                      ? (
                        <TestFinished setFinished={setFinished} testId={exam.testId} answers={answers} />
                      )
                      : (
                        <TestBody
                          descriptionRC={exam.descriptionRC}
                          descriptionKN={exam.descriptionKN}
                          descriptionOC={exam.descriptionOC || ''}
                          testData={exam.questions}
                          testId={exam.testId}
                          answers={answers}
                          timeLeft={timeLeft}
                        />
                      )
                    )
                    : (
                      <LandingExam activityId={activityId} exam={currentExam} />
                    )}

                  <LinearProgress className={classes.progressBar} variant="determinate" value={exam ? ((currentQuestion / exam.questions.length) * 100) : 0} />
                </Card>
              )
              : (
                <Grid container direction="row" justifyContent="center" style={{ marginTop: '50px' }}>
                  <Grid item md={12}>
                    <img className={classes.image} alt="placement test illustration" src={`${config.OBJECT_URL}/thumbnail/pt-landing.svg`} />
                  </Grid>

                  <Grid item md={12} className={classes.textCard}>
                    <Alert severity="info">
                      Votre examen a été envoyé à
                      {' '}
                      {isExamFinished.date}
                    </Alert>
                  </Grid>
                </Grid>
              )}
          </Container>
        )
        : <Loading />}
    </>
  );
};

PlacementTest.propTypes = {
  _id: PropTypes.string.isRequired,
  changePageTitle: PropTypes.func.isRequired,
  exam: PropTypes.object.isRequired,
  isTest: PropTypes.bool.isRequired,
  currentGroup: PropTypes.number.isRequired,
  additionalTime: PropTypes.number.isRequired,
  activityId: PropTypes.string.isRequired,
  setFinished: PropTypes.func.isRequired,
  setStarted: PropTypes.func.isRequired,
  currentExam: PropTypes.any.isRequired,
};

const actionCreators = {
  changePageTitle: uiActions.changePageTitle,
};

function mapState(state) {
  const { authData, isTest } = state.auth;
  const {
    requestingExam, exam, answers,
  } = state.exam;
  const { _id } = authData;
  const { currentGroup } = state.ui;
  const { additionalTime } = state.user.userData;

  return {
    _id,
    requestingExam,
    exam,
    isTest,
    answers,
    currentGroup,
    additionalTime,
  };
}

export default connect(mapState, actionCreators)(PlacementTest);
